import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type TableDeleteModalAction = "confirm" | "cancel";

export function useEmitTableDeleteModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: TableDeleteModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TableDeleteModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
